export default {
  setting: (state) => {
    return state.setting;
  },

  provinces: (state) => {
    return state.provinces;
  },
  provinceCode: (state) => {
    return state.provinceCode;
  },

  cities: (state) => {
    return state.cities;
  },
  cityCode: (state) => {
    return state.cityCode;
  },

  activityGroups: (state) => {
    return state.activityGroups;
  },
  activityGroupCode: (state) => {
    return state.activityGroupCode;
  },

  internalUnits: (state) => {
    return state.internalUnits;
  },
  internalUnitCode: (state) => {
    return state.internalUnitCode;
  },

  automationTypes: (state) => {
    return state.automationTypes;
  },
  automationTypeCode: (state) => {
    return state.automationTypeCode;
  },

  vehicles: (state) => {
    return state.vehicles;
  },
  vehicleCode: (state) => {
    return state.vehicleCode;
  },

  billboards: (state) => {
    return state.billboards;
  },
  billboard: (state) => {
    return state.billboard;
  },
  billboardCode: (state) => {
    return state.billboardCode;
  },

  serviceTypes: (state) => {
    return state.serviceTypes;
  },
  serviceTypeCode: (state) => {
    return state.serviceTypeCode;
  },

  tariffs: (state) => {
    return state.tariffs;
  },
  tariff: (state) => {
    return state.tariff;
  },
  tariffCode: (state) => {
    return state.tariffCode;
  },

  waterBillPeriods: (state) => {
    return state.waterBillPeriods;
  },
  waterBillPeriodCode: (state) => {
    return state.waterBillPeriodCode;
  },
  waterBillPeriodCheck: (state) => {
    return state.waterBillPeriodCheck;
  },

  notices: (state) => {
    return state.notices;
  },
  notice: (state) => {
    return state.notice;
  },
  noticeCode: (state) => {
    return state.noticeCode;
  },

  subscribers: (state) => {
    return state.subscribers;
  },
  subscriber: (state) => {
    return state.subscriber;
  },

  transactionInfos: (state) => {
    return state.transactionInfos;
  },
};
